import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import Home from "./Home";
import Footer from "./components/Footer";
import SecondMenu from "./components/SecondMenu";
import Departments from "./Departments";
import HolidaysList from "./HolidaysList";
import Convocation from "./Convocation";
import ContactUs from "./ContactUs";
import ScreenReader from "./ScreenReader";
import SedgCell from "./SedgCell";
import History from "./History";
import VisionMission from "./VisionMission";
import ChaudharyCharanSingh from "./ChaudharyCharanSingh";
import Chancellor from "./Chancellor";
import ViceChancellor from "./ViceChancellor";
import Governance from "./Governance";
import Administration from "./Administration";
import Deans from "./Deans";
import Wardens from "./Wardens";
import DeansStudentsWelfare from "./DeansStudentsWelfare";
import Proctors from "./Proctors";
import OfficerIncharge from "./OfficerIncharge";
import CellCoordinators from "./CellCoordinators";
import EngineeringSection from "./EngineeringSection";
import Dispensary from "./Dispensary";
import CulturalGallery from "./CulturalGallery";
import SportsGallery from "./SportsGallery";
import AcademicGallery from "./AcademicGallery";
import Faculty from "./Faculty";
import ProgOfferedCourses from "./ProgOfferedCourses";
import ProgOffered from "./ProgOffered";
import RegCourses from "./RegCourses";
import Gallery from "./Gallery";
import AdmissionBroucher from "./AdmissionBroucher";
import Admission from "./Admission";
import SelfFinanceCourse from "./SelfFinanceCourse";
import SkillDevelopment from "./SkillDevelopment";
import CampusSyllabus from "./CampusSyllabus";
import CollegeSyllabus from "./CollegeSyllabus";
import NepSyllabus from "./NepSyllabus";
import Facilities from "./Facilities";
import Library from "./Library";
import IQAC from "./IQAC";
import IqacAqarReports from "./IqacAqarReports";
import IqacMinutesofMeet from "./IqacMinutesofMeet";
import IqacPractices from "./IqacPractices";
import IqacCommitteeLetter from "./IqacCommitteeLetter";
import IqacNotifications from "./IqacNotifications";
import IqacInstitutionalDistinctiveness from "./IqacInstitutionalDistinctiveness";
import IqacIndustryConsultancyCell from "./IqacIndustryConsultancyCell";
import IqacFacilities from "./IqacFacilities";
import IqacProceedingACBOS from "./IqacProceedingACBOS";
import IqacStudentProjectsReports from "./IqacStudentProjectsReports";
import IqacAcademicCalendar from "./IqacAcademicCalendar";
import IqacAuditedStatement from "./IqacAuditedStatement";
import IqacFeedback from "./IqacFeedback";
import IqacActivities from "./IqacActivities";
import IqacContact from "./IqacContact";
import ExamRules from "./ExamRules";
import ExamRelatedInfo from "./ExamRelatedInfo";
import ExamSchedule from "./ExamSchedule";
import ExamForm from "./ExamForm";
import CodeBooks from "./CodeBooks";
import Syllabus from "./Syllabus";
import AntiRagging from "./AntiRagging";
import ConductDiscipline from "./ConductDiscipline";
import StudentCouncil from "./StudentCouncil";
import WomenCell from "./WomenCell";
import OMR from "./OMR";
import Career from "./Career";
import Download from "./Download";
import EnquiryNumbers from "./EnquiryNumbers";
import ImpEmails from "./ImpEmails";
import Tender from "./Tender";
import DeptSports from "./DeptSports";
import Nirf from "./Nirf";
import Infrastructure from "./Infrastructure";
import MobileApp from "./MobileApp";
import VCMessage from "./VCMessage";
import Affiliation from "./Affiliation";
import Research from "./Research";
import UniversityNewsLetter from "./UniversityNewsLetter";
import RTI from "./RTI";
import ITPolicy from "./ITPolicy";
import Activities from "./Activities";
import ActMissionShakti from "./ActMissionShakti";
import PhdDlit from "./PhdDlit";
import Verification from "./Verification";
import SahityikSanskritikParishad from "./SahityikSanskritikParishad";
import OnlinePayment from "./OnlinePayment";
import CollegeList from "./CollegeList";
import SportsCalendar from "./SportsCalendar";
import MediaReport from "./MediaReport";
import Abstract from "./Abstract";
import FacultyDetails from "./FacultyDetails";
import OmrDetails from "./OmrDetails";
import FacultyTypes from "./FacultyTypes";
import LeftOutPractical from "./LeftOutPractical";
import SearchNews from "./SearchNews";
import Sustainability from "./Sustainability";
import NotFound from "./NotFound";



function App() {
  return (
    <Router>
      <div>
        <Header />
        <TopBar />

        <Routes>
          <Route index element={<Home />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/faculty/:id/department/:id" element={<FacultyDetails />} />
          <Route path="/faculty" element={<Faculty />} />
          <Route path="/faculty/:id" element={<FacultyTypes />} />
          <Route path="/holidays-list" element={<HolidaysList />} />
          <Route path="/convocation" element={<Convocation />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/screen-reader" element={<ScreenReader />} />
          <Route path="/screen-reader" element={<ScreenReader />} />
          <Route path="/sedg-cell" element={<SedgCell />} />
          <Route path="/history" element={<History />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/chaudhary-charan-singh" element={<ChaudharyCharanSingh />} />
          <Route path="/chancellor" element={<Chancellor />} />
          <Route path="/vice-chancellor" element={<ViceChancellor />} />
          <Route path="/vice-chancellor-message" element={<VCMessage />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/administration" element={<Administration />} />
          <Route path="/deans-faculty" element={<Deans />} />
          <Route path="/wardens" element={<Wardens />} />
          <Route path="/deans-students-welfare" element={<DeansStudentsWelfare />} />
          <Route path="/proctors" element={<Proctors />} />
          <Route path="/officer-incharge" element={<OfficerIncharge />} />
          <Route path="/cell-and-coordinators" element={<CellCoordinators />} />
          <Route path="/engineering-section" element={<EngineeringSection />} />
          <Route path="/dispensary" element={<Dispensary />} />
          <Route path="/sports-gallery" element={<SportsGallery />} />
          <Route path="/cultural-gallery" element={<CulturalGallery />} />
          <Route path="/academic-gallery" element={<AcademicGallery />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/prog-offered-courses" element={<ProgOfferedCourses />} />
          <Route path="/prog-offered" element={<ProgOffered />} />
          <Route path="/regular-courses" element={<RegCourses />} />
          <Route path="/self-finance-courses" element={<SelfFinanceCourse />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/admission-brochure" element={<AdmissionBroucher />} />
          <Route path="/skill-development-syllabus" element={<SkillDevelopment />} />
          <Route path="/campus-syllabus" element={<CampusSyllabus />} />
          <Route path="/college-syllabus" element={<CollegeSyllabus />} />
          <Route path="/nep-syllabus" element={<NepSyllabus />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/library" element={<Library />} />
          <Route path="/iqac" element={<IQAC />} />
          <Route path="/iqac-aqar-report" element={<IqacAqarReports />} />
          <Route path="/iqac-meet" element={<IqacMinutesofMeet />} />
          <Route path="/iqac-practices" element={<IqacPractices />} />
          <Route path="/iqac-letter" element={<IqacCommitteeLetter />} />
          <Route path="/iqac-notifications" element={<IqacNotifications />} />
          <Route path="/distinctiveness" element={<IqacInstitutionalDistinctiveness />} />
          <Route path="/industry-consultancy-cell" element={<IqacIndustryConsultancyCell />} />
          <Route path="/iqac-facilities" element={<IqacFacilities />} />
          <Route path="/proceeding-ac-bos" element={<IqacProceedingACBOS />} />
          <Route path="/student-projects-reports" element={<IqacStudentProjectsReports />} />
          <Route path="/academic-calendar" element={<IqacAcademicCalendar />} />
          <Route path="/audited-statement" element={<IqacAuditedStatement />} />
          <Route path="/iqac-feedback" element={<IqacFeedback />} />
          <Route path="/iqac-activities" element={<IqacActivities />} />
          <Route path="/iqac-contact" element={<IqacContact />} />
          <Route path="/exam-rules" element={<ExamRules />} />
          <Route path="/exam-related-info" element={<ExamRelatedInfo />} />
          <Route path="/exam-schedule" element={<ExamSchedule />} />
          <Route path="/exam-form-and-admit-card" element={<ExamForm />} />
          <Route path="/code-books" element={<CodeBooks />} />
          <Route path="/downloads" element={<Download />} />
          <Route path="/syllabus" element={<Syllabus />} />
          <Route path="/anti-ragging" element={<AntiRagging />} />
          <Route path="/conduct-discipline" element={<ConductDiscipline />} />
          <Route path="/student-council" element={<StudentCouncil />} />
          <Route path="/women-cell" element={<WomenCell />} />
          <Route path="/omr" element={<OMR />} />
          <Route path="/omr/:id" element={<OmrDetails />} />
          <Route path="/career" element={<Career />} />
          <Route path="/enquiry-numbers" element={<EnquiryNumbers />} />
          <Route path="/imp-email" element={<ImpEmails />} />
          <Route path="/tenders" element={<Tender />} />
          <Route path="/dept-sports" element={<DeptSports />} />
          <Route path="/nirf" element={<Nirf />} />
          <Route path="/infra" element={<Infrastructure />} />
          <Route path="/mobile-app" element={<MobileApp />} />
          <Route path="/affiliation" element={<Affiliation />} />
          <Route path="/research" element={<Research />} />
          <Route path="/university-news-letter" element={<UniversityNewsLetter />} />
          <Route path="/rti" element={<RTI />} />
          <Route path="/it-policy" element={<ITPolicy />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/act-mission-shakti-2021" element={<ActMissionShakti />} />
          <Route path="/phd-dlit" element={<PhdDlit />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/sahityik-sanskritik-parishad" element={<SahityikSanskritikParishad />} />
          <Route path="/online-payment" element={<OnlinePayment />} />
          <Route path="/colleges" element={<CollegeList />} />
          <Route path="/sports-calendar" element={<SportsCalendar />} />
          <Route path="/media-report" element={<MediaReport />} />
          <Route path="/abstract-2021" element={<Abstract />} />
          <Route path="/left-out-practical" element={<LeftOutPractical />} />
          <Route path="/search-news" element={<SearchNews />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="*" element={<NotFound />} />

        </Routes>

        <SecondMenu />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
